export default {
  bodyForbidScroll: false,
  windowWidth: null,
  nextRefreshTime: null,
};
